import axios from 'axios'

var _accessToken = null
var _refreshToken = null

export function setAccessToken (token) {
  _accessToken = token || null
}

export function clearAccessToken () {
  _accessToken = null
}

export function setRefreshToken (token) {
  _refreshToken = token || null
}

export function clearRefreshToken () {
  _refreshToken = null
}

var http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:4000', 
  withCredentials: true
})

http.interceptors.request.use(function (config) {
  if (config._skipAuth) return config

  var token = _accessToken
  if (!token) {
    try {
      var persisted = JSON.parse(localStorage.getItem('vuex') || '{}')
      if (persisted.user) {
        token = persisted.user.accessToken || null
      }
    } catch (e) {}
  }

  if (token) {
    config.headers = config.headers || {}
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
}, function (err) {
  return Promise.reject(err)
})

// On 401, attempt one silent token refresh then retry the original request.
var _refreshPromise = null
var _sessionExpiredHandler = null
var _tokenRefreshedHandler = null

export function setSessionExpiredHandler (fn) {
  _sessionExpiredHandler = fn
}

export function setTokenRefreshedHandler (fn) {
  _tokenRefreshedHandler = fn
}

http.interceptors.response.use(
  function (response) { return response },
  function (error) {
    var config = error.config
    var status = error.response && error.response.status

    if (
      status !== 401 ||
      !config ||
      config._retry ||
      (config.url || '').includes('/auth/')
    ) {
      return Promise.reject(error)
    }

    config._retry = true

    if (!_refreshPromise) {
      var rt = _refreshToken
      if (!rt) {
        try {
          var saved = JSON.parse(localStorage.getItem('vuex') || '{}')
          rt = saved.user && saved.user.refreshToken
          if (rt) _refreshToken = rt
        } catch (e) {}
      }
      var refreshBody = rt ? { refreshToken: rt } : {}
      _refreshPromise = http
        .post('/auth/refresh', refreshBody, { _skipAuth: true })
        .then(function (res) {
          setAccessToken(res.data.accessToken)
          if (res.data.refreshToken) setRefreshToken(res.data.refreshToken)
          if (_tokenRefreshedHandler) {
            var updated = { accessToken: res.data.accessToken }
            if (res.data.refreshToken) updated.refreshToken = res.data.refreshToken
            _tokenRefreshedHandler(updated)
          }
          _refreshPromise = null
          return res.data.accessToken
        })
        .catch(function () {
          _refreshPromise = null
          clearAccessToken()
          clearRefreshToken()
          if (_sessionExpiredHandler) _sessionExpiredHandler()
          return Promise.reject(new Error('session_expired'))
        })
    }

    return _refreshPromise.then(function (token) {
      config.headers['Authorization'] = 'Bearer ' + token
      return http(config)
    }).catch(function (refreshErr) {
      // Refresh failed — the endpoint 401'd in the first place, so it requires auth;
      // retrying without a token would just 401 again with no useful detail, masking
      // "your session expired" behind a generic failure. Reject clearly instead so
      // callers can tell a real session expiry apart from an ordinary request error.
      refreshErr.isSessionExpired = true
      return Promise.reject(refreshErr)
    })
  }
)

export default http
